import { render } from "./DesktopMenuDisplay.vue?vue&type=template&id=12f79cfc&scoped=true"
import script from "./DesktopMenuDisplay.vue?vue&type=script&lang=js"
export * from "./DesktopMenuDisplay.vue?vue&type=script&lang=js"

import "./DesktopMenuDisplay.vue?vue&type=style&index=0&id=12f79cfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f79cfc"]])

export default __exports__